import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, withModifiers as _withModifiers, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/luckycards/popup_order_bg.png';
import _imports_1 from '@assets/images/luckycards/detail_default_icon.png';
const _withScopeId = n => (_pushScopeId("data-v-2089fc63"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top-img",
  src: _imports_0
}, null, -1));
const _hoisted_2 = {
  class: "popup-order-content"
};
const _hoisted_3 = {
  key: 0,
  class: "loading"
};
const _hoisted_4 = {
  key: 0,
  class: "address-box"
};
const _hoisted_5 = {
  class: "detail-top"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "detail-default-icon",
  src: _imports_1
}, null, -1));
const _hoisted_7 = {
  class: "detail-bottom"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-next"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 新增收货地址");
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-next"
}, null, -1));
const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = {
  class: "content-info"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "order-info"
};
const _hoisted_15 = {
  class: "name"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "gray"
}, "不支持7天无理由退换货", -1));
const _hoisted_17 = {
  class: "info"
};
const _hoisted_18 = {
  class: "money"
};
const _hoisted_19 = {
  class: "num"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "未成年人请勿下单，卡包一经售出概不退换", -1));
const _hoisted_21 = {
  class: "scroll-box"
};
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 泰国用户未开通支付宝/微信支付？");
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "txt"
}, "切换支付方式", -1));
const _hoisted_24 = [_hoisted_22, _hoisted_23];
const _hoisted_25 = {
  key: 1,
  class: "pay-box"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信支付", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "支付宝", -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我已满18岁，同意", -1));
const _hoisted_31 = {
  class: "rules-tips"
};
const _hoisted_32 = {
  key: 0,
  class: "probability-box"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "商品抽奖存在概率性，付费请谨慎", -1));
const _hoisted_34 = {
  class: "name"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "right"
}, "]", -1));
const _hoisted_36 = {
  class: "num"
};
const _hoisted_37 = {
  class: "bottom"
};
const _hoisted_38 = {
  class: "money"
};
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 合计：");
const _hoisted_40 = ["innerHTML"];
const _hoisted_41 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $options.showOrder,
    "onUpdate:show": _cache[11] || (_cache[11] = $event => $options.showOrder = $event),
    "close-on-click-overlay": false,
    position: "bottom",
    "transition-appear": true,
    transition: "fade",
    class: "popup-order-box",
    onOpen: $options.open
  }, {
    default: _withCtx(() => [!$data.showLoading ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : _createCommentVNode("", true), !($props.order_id && $props.pay_amount) ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [$options.origin_type == 'project' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [$data.addressItem && JSON.stringify($data.addressItem) != '{}' ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "address",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.goToAddressList && $options.goToAddressList(...args))
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("strong", null, _toDisplayString($data.addressItem.address_name), 1), _createElementVNode("span", null, _toDisplayString($data.addressItem.address_mobile), 1), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, _toDisplayString($data.addressItem.province) + _toDisplayString($data.addressItem.city) + _toDisplayString($data.addressItem.county) + _toDisplayString($data.addressItem.address), 1), _hoisted_8])])) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "address",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.goToAddressList && $options.goToAddressList(...args))
    }, _hoisted_11))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
      class: "img",
      src: _ctx.$imgUrlFilter($props.cards_info.detail_image_url || '', 400)
    }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString($props.name), 1), _hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("strong", _hoisted_18, "￥" + _toDisplayString($data.sitem.sale_price), 1), _createElementVNode("i", {
      class: _normalizeClass(['reduce', {
        gray_num: $data.num <= 1
      }]),
      onClick: _cache[2] || (_cache[2] = (...args) => $options.reduceNum && $options.reduceNum(...args))
    }, "-", 2), _createElementVNode("span", _hoisted_19, _toDisplayString($data.num), 1), _createElementVNode("i", {
      class: _normalizeClass(['add', {
        gray_num: $data.sitem.type_code == 2 || $data.sitem.type_code == 3 || $data.sitem.type_code == 1 && $data.num == 20
      }]),
      onClick: _cache[3] || (_cache[3] = (...args) => $options.addNum && $options.addNum(...args))
    }, "+", 2)]), _hoisted_20])])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, [$props.cards_info.change_pay ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "changePay",
      onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.tabThailand && $options.tabThailand(...args), ["stop"]))
    }, _hoisted_24)) : _createCommentVNode("", true), !$data.env.isWeixin() && !$data.env.isWeibo() ? (_openBlock(), _createElementBlock("div", _hoisted_25, [!$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "pay-way pay-way-wx",
      onClick: _cache[5] || (_cache[5] = $event => $options.changePayType('weixin_mina'))
    }, [_hoisted_26, _hoisted_27, _createElementVNode("b", {
      class: _normalizeClass(['check-icon', {
        active: $options.pay_resource == 'weixin_mina' || $options.pay_resource == 'weixin'
      }])
    }, null, 2)])) : _createCommentVNode("", true), !$data.env.isWeixin() ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "pay-way pay-way-ali",
      onClick: _cache[6] || (_cache[6] = $event => $options.changePayType('alipay'))
    }, [_hoisted_28, _hoisted_29, _createElementVNode("b", {
      class: _normalizeClass(['check-icon', {
        active: $options.pay_resource == 'alipay'
      }])
    }, null, 2)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "agreement",
      onClick: _cache[8] || (_cache[8] = $event => $data.agreementChecked = !$data.agreementChecked)
    }, [_hoisted_30, _createElementVNode("a", {
      onClick: _cache[7] || (_cache[7] = (...args) => $options.jumpA && $options.jumpA(...args))
    }, "《服务协议》"), _createElementVNode("b", {
      class: _normalizeClass(['check-icon', {
        active: $data.agreementChecked
      }])
    }, null, 2)]), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.rulesList, (item, index) => {
      return _openBlock(), _createElementBlock("p", {
        key: index
      }, _toDisplayString(item.context), 1);
    }), 128)), $props.probabilityList.length ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_hoisted_33, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.probabilityList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "probability-item",
        key: index
      }, [_createElementVNode("span", _hoisted_34, "[" + _toDisplayString(item.level_name), 1), _hoisted_35, _createElementVNode("span", _hoisted_36, _toDisplayString(item.probability), 1)]);
    }), 128))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("span", null, "￥" + _toDisplayString($data.amount), 1)]), _createElementVNode("div", {
      class: "sub_btn",
      onClick: _cache[9] || (_cache[9] = (...args) => $options.subOrder && $options.subOrder(...args))
    }, "提交")]), _createElementVNode("i", {
      class: "popup-order-close-icon",
      onClick: _cache[10] || (_cache[10] = (...args) => $options.close && $options.close(...args))
    }), $data.html ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: "html",
      ref: "html",
      innerHTML: $data.html
    }, null, 8, _hoisted_40)) : _createCommentVNode("", true), _createElementVNode("iframe", {
      style: {
        "width": "0",
        "height": "0",
        "position": "absolute",
        "opacity": "0",
        "z-index": "-1"
      },
      id: "webActivityShow",
      class: "dragArea list-group iphone-dragArea",
      src: $data.iframeUrl
    }, null, 8, _hoisted_41)])], 64)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["show", "onOpen"]);
}